export const footerConfig = {
  payments: [
    'Juridinio asmens kodas 304690904',
    'PVM mokėtojo kodas LT100012779613',
    'Sąskaitos numeris LT117300010153243368',
    'Swedbank AB',
  ],
};
